export const LS_USER_SUBSCRIPTIONS = 'user-subscriptions'
export const LS_ACCESSTOKEN = 'access-tokens'
export const LS_MONACCESSTOKEN = 'monetization-access-token'
export const LS_USER = 'user'
export const LS_RATINGS = 'ratings'
export const LS_SUBSCRIPTIONS = 'subscriptions'
export const LS_PURCHASES = 'purchases'
export const LS_LOCAL_MODS = 'local-mods'
export const LS_ACTIVATIONS = 'activations'
export const LS_COOKIE = 'cookies'
export const LS_KARMA = 'karma'
export const LS_TEAMS = 'teams'
export const LS_CACHE_END_TS = 'cache-end-ts'
export const LS_REUSE_PERMISSIONS = 'reuse-permissions'
export const LS_COLLECTIONS_FOLLOWING = 'collections-following'
export const LS_MUTED_USERS = 'muted-users'
export const LS_BLOCKED_USERS = 'blocked-users'
export const LS_PARTNER_PROGRAMS = 'partner-programs'

export const SS_REDIRECT = 'redirect'
export const SS_TILIA_CALLBACK = 'tilia-callback'
export const SS_TRANSACTION_KEY = 'transaction-key'
export const SS_COLLECTIONS_FOLLOWING_REFRESHED =
  'collection-following-refreshed'
